import { colors } from '../../theme/color';

export const mapColorNameToColor = (color?: string): string => {
  switch (color) {
    case 'orange':
      return colors.orange.darker(10);
    default:
      return colors.textDefault;
  }
};
